import * as React from "react";
import {imageBaseUrl} from "config";
import {Button} from "web-com";
import {useEffect, useState} from "react";
import "./style.scss";
import {partnerOfferings} from "login/config";
interface IProps {
    duration?: number;
    text?: string;
    onFinish: () => void;
    utm_source?: string;
}
const defaultDuration = 15;
const defaultText = "Please wait while we are processing.";
const Timer = (props: IProps) => {
    const [time, setTime] = useState(props.duration ? props.duration : defaultDuration);
    useEffect(() => {
        startTimer();
    }, []);
    const startTimer = () => {
        let stopWatch = time;
        const timer = setInterval(() => {
            if (stopWatch > 0) {
                stopWatch = stopWatch - 1;
                setTime((prev) => prev - 1);
            } else {
                props.onFinish();
                clearInterval(timer);
            }
        }, 1000);
    };
    return (
        <div className="flex-column-center-row">
            <div className="flex-center timer-text">Please wait for a while</div>
            <div className="timer-logo-container">
                <img className="timer-logo" src={partnerOfferings[props.utm_source]?.loaderImage ? partnerOfferings[props.utm_source]?.loaderImage : `${imageBaseUrl}/img/consent/processing.png`} alt="loading"/>
            </div>
            <div className="timer-msg">
                {props.text ? props.text : defaultText}
            </div>
            {time > 0 && <Button bgColor={partnerOfferings[props.utm_source]?.colors?.green} buttonText={`${time} sec`} rounded={true}/>}
        </div>
    );
};

export default Timer;
